import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  Action,
  MutationUnsuspendMemberArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getMemberKey, getMembersKey } from '../../utils/keys/member.key.js'

export const useUnsuspendMember = (options?: {
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationUnsuspendMemberArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Action, ClientError, MutationUnsuspendMemberArgs>(
    variables =>
      client.mutation({
        name: 'unsuspendMember',
        args: {
          fields: 'basic',
          variables,
        },
      }),
    {
      onSettled: (data, error, variables) => {
        const memberKey = getMemberKey({
          variables: { id: variables?.memberId },
        })
        queryClient.invalidateQueries(memberKey)

        const membersKey = getMembersKey()
        queryClient.invalidateQueries(membersKey)
      },
      ...useMutationOptions,
    },
  )
}
